import React, { Component } from 'react'
import { filter } from 'helpers/decorators'
import { Input, Select } from 'components/fields'
import { Module, FilterActions, Row, Col } from 'components/misc'
import { connect } from 'react-redux'
import { tasks as tasksApi } from 'redux/modules/api'
import PropTypes from 'prop-types'
import { apiOrganizations } from '../../../helpers/decorators/api'
import { compose } from 'recompose'
import { ORGANIZATION_HIERARCHY } from '../../../constants/enums'
import { mapAwardUnits } from '../../../helpers/mapForSelect'

const enhance = compose(
  apiOrganizations(),
  connect(
    ({ api }) => ({
      query: api.tasks.invitedParticipants.filter,
      count: api.tasks.invitedParticipants.count
    }),
    {
      setFilter: tasksApi.invitedParticipants.setTasksInvitedParticipantsFilter
    }
  ),
  filter({
    form: 'invited-participants-filter',
    persist: true
  })
)

class FilterTasksInvitedParticipants extends Component {
  static propTypes = {
    activeOrganization: PropTypes.object.isRequired,
    getCustomOrganizations: PropTypes.func.isRequired
  }

  searchAwardCentres = search => {
    const { activeOrganization } = this.props
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    return this.props.getCustomOrganizations(params,
      `flatHierarchy.parentOrganization.id=${activeOrganization.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id}`, {}, {
        onlyActive: true,
        disableLimit: false
      })
      .then(obj => obj.body)
      .then(obj => mapAwardUnits({ list: obj }))
  }

  render() {
    return (
      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
          <Col flex="0 1 200px">
            <Input
              label="Search"
              intlKey="label.search"
              name="participantRegistration_firstName||participantRegistration_lastName||participantRegistration_email"
              clearable
            />
          </Col>
          <Col flex="0 1 200px">
            <Select
              label="Award Centre"
              intlKey="label.award_unit"
              name="participantRegistration_organizationId@or"
              multi
              autocomplete
              promise={this.searchAwardCentres}
              placeholder="Start typing ..."
              intlKeyPlaceholder="placeholder.start_typing"
              backspaceToRemoveMessage={''}
            />
          </Col>
          <Col flex="1 1 auto" alignSelf="flex-end" right>
            <FilterActions {...this.props} />
          </Col>
        </Row>
      </Module>
    )
  }
}

export default enhance(FilterTasksInvitedParticipants)
